import {createRouter, createWebHashHistory, RouteRecordRaw} from "vue-router";

export const routes: Array<RouteRecordRaw> = [
    {
        path: '/',
        component: () => import('@/layout/index.vue'),
        redirect: '/index',
        children: [
            // layout
            {
                path: 'index',
                name: 'index',
                meta: {
                    title: 'index'
                },
                component: () => import('@/views/home/index.vue'),
            },
        ],
    },
    {
        path: '/agreement',
        name: 'agreement',
        component: () => import('@/views/policy-agreement/index.vue'),
    },
    {
        path: '/white-bg-agreement',
        name: 'white-bg-agreement',
        component: () => import('@/views/white-bg-policy-agreement/index.vue'),
    },
    {
        path: '/error',
        name: 'error',
        component: () => import('@/views/error/index.vue'),
    },
    // 替代Vue2中 ‘*’ 通配符路径
    {path: '/:pathMatch(.*)*', redirect: '/'}
];

const router = createRouter({
    history: createWebHashHistory(),// history 模式
    routes,
})

export default router;
